import { render, staticRenderFns } from "./TorqRgst.vue?vue&type=template&id=00a42550&"
import script from "./TorqRgst.vue?vue&type=script&lang=js&"
export * from "./TorqRgst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports